<template>
  <div
    class="relative w-full overflow-hidden rounded-3xl"
    @click="openSpecialOfferDetails"
  >
    <div
      class="absolute inset-0 w-full bg-cover bg-no-repeat"
      :style="{ backgroundImage: `url(${img})` }"
    ></div>

    <div
      class="absolute inset-0"
      style="
        background: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 0.6) 100%
        );
      "
    ></div>

    <div
      class="relative flex min-h-64 w-full flex-col justify-between gap-2 p-4"
      :class="{
        'items-center text-center': isCentered,
        'pb-10': isCentered && !isSingleOffer,
      }"
    >
      <div v-if="tags?.length" class="flex items-center gap-2 self-start">
        <SpecialOfferTag v-for="tag in tags" :key="tag" :title="tag" />
      </div>
      <div class="flex flex-col gap-1" :class="{ 'items-center': isCentered }">
        <p class="text-static-white text-lg font-semibold">
          {{ title }}
        </p>
        <p v-if="description" class="text-static-white/80 text-sm">
          {{ description }}
        </p>
        <div
          class="text-text-neutral-secondary bg-situational-lightgrey mt-2 w-fit rounded-2xl px-6 py-2 text-xs font-medium"
        >
          <span v-if="price">
            {{
              t('general.price.startFrom', {
                price: prettyPrice(price.amount || '0'),
              })
            }}
          </span>
          <span> → </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { prettyPrice } from '@aviata/text-fns';
  import { useI18n } from 'vue-i18n';
  import { useRouter } from 'vue-router';

  import { BannerType } from '@/entities/special-offers';

  import { amplitudeEventsLib } from '@/shared/lib';

  import SpecialOfferTag from './SpecialOfferTag.vue';

  const props = withDefaults(
    defineProps<{
      id: string;
      title: string;
      description?: string | null;
      isCentered?: boolean;
      isSingleOffer?: boolean;
      img?: string | null;
      price?: { currency: string; amount: string };
      tags?: string[];
      bannerType?: BannerType;
      source?: 'main' | 'all_special_offers';
    }>(),
    {
      bannerType: BannerType.FLIGHTS,
      source: 'main',
    },
  );

  const { t } = useI18n();
  const router = useRouter();

  const openSpecialOfferDetails = () => {
    amplitudeEventsLib.specialOffersClicked({
      bannerId: props.id,
      bannerName: props.title,
      bannerType: props.bannerType,
      source: props.source,
    });

    router.push({
      name: 'SpecialOfferDetails',
      params: { offerId: props.id },
      query: { source: props.source },
    });
  };
</script>
